import { SET_MODAL_DATA, TOGGLE_MODAL, RESET_MODAL_DATA } from 'redux/actions/actionTypes';

const initialState = {
  visible: false,
  modalChildren: null,
  modalProps: {},
  type: 'halfcard',
};

export default (state = initialState, { payload, type }) => {
  switch (type) {
    case TOGGLE_MODAL: {
      return {
        ...state,
        visible: !state.visible,
      };
    }

    case RESET_MODAL_DATA: {
      return {
        ...initialState,
      };
    }

    case SET_MODAL_DATA: {
      return {
        ...state,
        ...payload,
      };
    }

    default:
      return state;
  }
};
